import { render } from "./DeleteConfirmDialog.vue?vue&type=template&id=2c17c8f4"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script